import { cx } from '@linaria/core';
import { useRef } from 'react';
import { units } from '@ui/css';
import { tokens, aspectCls, contentCls, boundaryCls } from './comp.boundary.style.js';
import { getAspectRatio } from './util.get-aspect-ratio.js';
import { shouldOpenInLightbox } from './util.should-open-in-lightbox.js';
import { jsx } from 'react/jsx-runtime';

function Boundary(props) {
  const ref = useRef(null);
  const aspect = getAspectRatio({
    displayData: props.displayData,
    previewImageScale: props.previewImageDimensions?.scale
  });
  const opensInLightbox = shouldOpenInLightbox({
    componentRef: ref,
    displayData: props.displayData,
    forceOpenInLightbox: props.forceOpenInLightbox
  }) && !props.inLightbox;
  const maxWidth = props.previewImageDimensions?.maxWidth ?? props.displayData?.maxSize?.width;
  const maxHeight = props.previewImageDimensions?.maxHeight ?? props.displayData?.maxSize?.height;
  const height = !props.inLightbox && props.displayData?.fixedHeight ? props.displayData.proportions.height : undefined;
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: cx(boundaryCls, !!height && "fixedHeight", props.inLightbox && "inLightbox", props.hasPreviewImage && "withPreviewImage", props.hasPreviewImage && !props.previewImageDimensions && "isLoadingPreview", opensInLightbox && "opensInLightbox"),
    style: tokens.__override({
      aspect: !height ? aspect : 0,
      height: height ? units.px(height) : undefined,
      maxWidth: maxWidth ? units.px(maxWidth) : undefined,
      maxHeight: maxHeight ? units.px(maxHeight) : undefined
    }),
    children: /*#__PURE__*/jsx("div", {
      className: aspectCls,
      children: /*#__PURE__*/jsx("div", {
        className: contentCls,
        children: props.children
      })
    })
  });
}

export { Boundary };
//# sourceMappingURL=comp.boundary.js.map
